import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ProjectInsight001 from '../../../../assets/ProjectInsight001.png';
import ProjectInsight002 from '../../../../assets/ProjectInsight002.png';
import {
  BACKGROUND_BLACK,
  BACKGROUND_LIGHT_BLACK,
  ORANGE,
  WHITE,
  LIGHT_BLUE,
} from '../../../../styles/Colors';
import { HEADER_HIGHT } from '../../../../styles/LayoutSetting';
import {
  mobileDevice,
  largeDevice,
} from '../../../../constants/DeviceBreakPoints';
import {
  Mobile,
  Default,
} from '../../../../components/MediaQueryComponent';

const styles = theme => ({
  screenContainer: {
    backgroundColor: BACKGROUND_BLACK,
    padding: '20px 20px',
    width: '100vw',
    minHeight: `calc(100vh - ${HEADER_HIGHT}px)`,
    [theme.breakpoints.up(largeDevice)]: {
      maxHeight: 900,
      height: `calc(100vh - ${HEADER_HIGHT}px)`,
      minHeight: 'auto',
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  mobileBackground: {
    backgroundColor: BACKGROUND_LIGHT_BLACK,
  },
  wrapperContainer: {
    width: '100%',
    maxWidth: 1400,
    border: `1px solid ${ORANGE}`,
    borderRadius: 20,
    padding: 10,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down(mobileDevice)]: {
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
  },
  imageContainer: {
    width: '50%',
  },
  imageText: {
    fontFamily: 'Quicksand, sans-serif',
    color: LIGHT_BLUE,
    fontSize: 16,
    textAlign: 'center',
    margin: '10px 0',
    [theme.breakpoints.down(mobileDevice)]: {
      fontSize: 12,
    },
  },
  imageRowContainer: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down(mobileDevice)]: {
      maxHeight: '40vh',
    },
  },
  imageStyle: {
    margin: '0 10px',
    maxHeight: 400,
    width: '40%',
    objectFit: 'contain',
    [theme.breakpoints.up(largeDevice)]: {
      maxHeight: `calc((100vh - ${HEADER_HIGHT}px)*0.8)`,
    },
  },
  textContainer: {
    width: '50%',
  },
  titleText: {
    fontFamily: 'Poppins, sans-serif',
    color: ORANGE,
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: 'left',
    lineHeight: 1.2,
    padding: '8px 0',
    marginBottom: 10,
    [theme.breakpoints.down(mobileDevice)]: {
      fontSize: 18,
      textAlign: 'center',
    },
  },
  mainText: {
    fontSize: 30,
    textAlign: 'center',
    [theme.breakpoints.down(mobileDevice)]: {
      fontSize: 18,
    },
  },
  descriptionContainer: {
    margin: '10px 0',
    [theme.breakpoints.down(mobileDevice)]: {
      margin: '4px 0',
    },
  },
  descriptionText: {
    fontFamily: 'Quicksand, sans-serif',
    color: WHITE,
    fontSize: 18,
    textAlign: 'center',
    [theme.breakpoints.down(mobileDevice)]: {
      fontSize: 16,
    },
  },
  highlightText: {
    color: ORANGE,
  },
});

const ComingSoonSection = ({
  classes,
}) => {
  const ImageTitle = (
    <div className={classes.imageText}>
      Project Insight
    </div>
  );
  const ImagesRow = (
    <div className={classes.imageRowContainer}>
      <img
        alt="ProjectInsight001"
        src={ProjectInsight001}
        className={classes.imageStyle}
      />
      <img
        alt="ProjectInsight002"
        src={ProjectInsight002}
        className={classes.imageStyle}
      />
    </div>
  );
  const SubTitle = (
    <div className={classes.titleText}>
      Enhance Your Team’s Performance
    </div>
  );
  const DescriptionText = (
    <React.Fragment>
      <div className={classes.descriptionContainer}>
        <span className={classes.descriptionText}>
          {[
            'Construction insights used to take years of experience to acquire.',
            'With LinkedField, you just carry a smartphone, and our VIRTUAL PROJECT MANAGER does the rest - ',
          ].join(' ')}
        </span>
        <span className={`${classes.descriptionText} ${classes.highlightText}`}>
          {[
            'LinkedField\'s proprietary Insights Engine product pushes relevant',
            'and targeted constructibility insights automatically, without any extra labor.',
          ].join(' ')}
        </span>
      </div>
      <div className={classes.descriptionContainer}>
        <span className={classes.descriptionText}>
          {[
            'Each team member just carries their smartphone, interacts with VIRTUAL PROJECT MANAGER and that\'s it.',
            'LinkedField\'s Insights Engine is always learning, so the more you interact',
            'with the Virtual Project Manager the faster and better LinkedField works.',
          ].join(' ')}
        </span>
        <span className={`${classes.descriptionText} ${classes.highlightText}`}>
          {[
            'We help ensure your project team members have the ability',
            'to stay on top of critical activities - even when schedule and site conditions change.',
          ].join(' ')}
        </span>
      </div>
    </React.Fragment>
  );
  return (
    <React.Fragment>
      <Mobile>
        <div className={`${classes.screenContainer} ${classes.mobileBackground}`}>
          <div className={`${classes.titleText} ${classes.mainText}`}>
            Request Access
          </div>
          <div className={classes.wrapperContainer}>
            {SubTitle}
            {ImagesRow}
            {ImageTitle}
            {DescriptionText}
          </div>
        </div>
      </Mobile>
      <Default>
        <div className={classes.screenContainer}>
          <div className={`${classes.titleText} ${classes.mainText}`}>
            Request Access
          </div>
          <div className={classes.wrapperContainer}>
            <div className={classes.imageContainer}>
              {ImageTitle}
              {ImagesRow}
            </div>
            <div className={classes.textContainer}>
              {SubTitle}
              {DescriptionText}
            </div>
          </div>
        </div>
      </Default>
    </React.Fragment>
  );
};

ComingSoonSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ComingSoonSection);
